/**
 * FP3-033 — Tiny entry-point buttons for Print / Display output
 * routes. Opens in a new tab per user choice so the working
 * dashboard stays alive.
 */
import { Printer, Television } from "@phosphor-icons/react";

function open(url) {
  if (typeof window === "undefined") return;
  window.open(url, "_blank", "noopener,noreferrer");
}

export function PrintDisplayActions({
  printHref,
  displayHref,
  label,
  testIdPrefix,
  compact = false,
}) {
  const cls = compact
    ? "inline-flex items-center gap-1 text-[11px] font-medium text-[#3F4756] hover:text-[#1E3F33] px-2 py-1 rounded-md border border-[#E5E3DB] hover:bg-[#F9F8F6]"
    : "inline-flex items-center gap-1.5 text-[12px] font-medium text-[#3F4756] hover:text-[#1E3F33] px-2.5 py-1.5 rounded-md border border-[#E5E3DB] hover:bg-[#F9F8F6]";
  return (
    <div className="inline-flex items-center gap-2" aria-label={label}>
      {printHref && (
        <button
          type="button"
          data-testid={`${testIdPrefix}-print-btn`}
          onClick={() => open(printHref)}
          className={cls}
          title="Open print view in a new tab"
        >
          <Printer size={compact ? 11 : 12} weight="duotone" />
          Print
        </button>
      )}
      {displayHref && (
        <button
          type="button"
          data-testid={`${testIdPrefix}-display-btn`}
          onClick={() => open(displayHref)}
          className={cls}
          title="Open display view in a new tab"
        >
          <Television size={compact ? 11 : 12} weight="duotone" />
          Display
        </button>
      )}
    </div>
  );
}
